/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import { FC } from 'react';

import { DroppableProvided } from 'react-beautiful-dnd';

import DraggableItem from './DraggableItem';

/**
 * @description Define interface for droppable container for rendering dragable items.
 * @interface IDroppableContainer
 *
 * @property {DroppableProvided} provided Draggable provider.
 * @property {JSX.Element[]} items Items for rendering in container.
 * @property {string} icon Define icon for move draggable items.
 */
interface IDroppableContainer {
    provided: DroppableProvided;
    items: JSX.Element[];
    icon: string;
}

const DroppableContainer: FC<IDroppableContainer> = (props: IDroppableContainer) => (
    <div {...props.provided.droppableProps} ref={props.provided.innerRef}>
        {
            props.items.map((item: JSX.Element, index: number) => {
                    return <DraggableItem
                        icon={props.icon}
                        index={index}
                        item={item}
                        key={item.props.order}
                    />;
                },
            )
        }
        {props.provided.placeholder}
    </div>
);

export default DroppableContainer;
